import { jsx as _jsx } from "react/jsx-runtime";
export var JobTypeStatus = function (_a) {
    var children = _a.children;
    return (_jsx("div", { className: 'bg-cardJobTypeStatusBackground text-cardJobTypeStatusTextColor text-cardJobTypeStatusFontSize font-cardHeadingFontWeight rounded-md px-1 py-0.5 uppercase', children: children }));
};
